import { FormControl, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';
import React from 'react';

type BooleanInputProperties = Omit<SelectProps, 'value' | 'onChange'> & {
  value: boolean | undefined;
  onChange: (value: boolean) => void;
  trueLabel?: string;
  falseLabel?: string;
};

const getSelectValue = (booleanValue: boolean | undefined): string => {
  if (booleanValue === undefined) {
    return '';
  }
  return booleanValue ? 'true' : 'false';
};

export const BooleanInput = React.forwardRef<HTMLSelectElement, BooleanInputProperties>(
  ({ value, onChange, trueLabel = 'true', falseLabel = 'false', ...properties }, reference) => {
    return (
      <FormControl fullWidth size='small' data-testid='boolean-input'>
        <InputLabel id='value-select-label'>Value</InputLabel>
        <Select
          labelId='value-select-label'
          label='Value'
          value={getSelectValue(value)}
          onChange={event => onChange(event.target.value === 'true')}
          variant='outlined'
          ref={reference}
          {...properties}
          sx={{
            borderRadius: '8px',
            ...properties.sx,
          }}
        >
          <MenuItem value='true'>{trueLabel}</MenuItem>
          <MenuItem value='false'>{falseLabel}</MenuItem>
        </Select>
      </FormControl>
    );
  }
);

BooleanInput.displayName = 'BooleanInput';
